export { FrequentlyAskedQuestions } from './frequently_asked_questions'
export { Home } from './home'
export { TermsAndConditions } from './terms_and_conditions'
export { LinkTo } from './link-to'



// WEBPACK FOOTER //
// ./src/pages/index.js